import React from 'react'

export default class InvoiceStatusSelect extends React.Component {
    constructor(props) {
        super(props);

        var colSize = 2;
        var title = "Select an invoice status:";
        var sortID = "Pending";
        var styles;

        if(this.props.columnSize !== undefined)
        {
            colSize = this.props.columnSize;
        }
        if(this.props.title !== undefined)
        {
            title = this.props.title;
        }
        if(this.props.sortID !== undefined || this.props.sortID != "")
        {
            sortID = this.props.sortID;
        }
        if(this.props.padding !== undefined)
        {
            styles = {
                padding: this.props.padding
            }
        }

        this.options = {
            columnSize: "col-sm-" + colSize,
            title: title,
            sortID: sortID,
            styles: styles
        }

    }

    componentDidMount() {
    }

    componentWillUpdate(nextProps, nextState) {
        if(nextProps.sortID === undefined || nextProps.sortID == "") {
            this.options.sortID = "Pending";
        } else {
            this.options.sortID = nextProps.sortID;
        }
    }

    render(){
        const options = this.options;
        return (
            <div class={options.columnSize} style={options.styles}>
                <small>{options.title}</small>
                <select class="form-control" value={options.sortID} onChange={this.props.onChange}>
                    <option value="Submitted">Submitted</option>
                    <option value="In Reviewed">In Review</option>
                    <option value="Approved">Approved</option>
                    <option value="Processed">Processed</option>
                </select>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/helpers/Invoices/InvoiceStatusSelect.jsx